import {
    extractProperties,
    isEmpty,
} from '.'
import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatQueueActivityEvent} from '../types/events'
import {NinchatState} from 'api/types'

export const queueActivity: CaseReducer<NinchatState> = (state, action) => {
    const {
        queue_activity,
        queue_id,
        ...rest
    } = extractProperties<NinchatQueueActivityEvent>(action.payload)

    isEmpty(rest)

    const isSelfTriggered = !!action.payload.action_id

    if (!isSelfTriggered) {
        return
    }

    const activities = queue_activity.filter((activity) => (activity.event === 'queue_updated' ? typeof activity.queue_attrs?.closed === 'boolean' : true))

    state._user_queues_activity[queue_id] = activities
}
